/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getReviewerPerformanceSummaryV1QuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(90).default(30),
});

export type IGetReviewerPerformanceSummaryV1Query = z.input<
  typeof getReviewerPerformanceSummaryV1QuerySchema
>;
